module.exports = __webpack_public_path__ + "img/violet_078.4af655a1.png";